import { createContext, useContext, useMemo, useState } from 'react';
import type { ReactNode } from 'react';

type CurrencyProviderProps = {
  children: ReactNode;
};

type CurrencyContext = {
  currency: 'EUR' | 'GBP' | undefined;
  setCurrency: (t: 'EUR' | 'GBP' | undefined) => void;
};

const CurrencyContext = createContext<CurrencyContext>({
  currency: undefined,
  setCurrency: () => null,
});

const CurrencyProvider = ({ children }: CurrencyProviderProps) => {
  const [currency, setCurrency] = useState<'EUR' | 'GBP' | undefined>(
    undefined,
  );

  const value = useMemo(() => ({ currency, setCurrency }), [currency]);

  return (
    <CurrencyContext.Provider value={value}>
      {children}
    </CurrencyContext.Provider>
  );
};

const useCurrency = () => useContext(CurrencyContext);

export { CurrencyProvider, useCurrency };
